<template>
    <a href="/" class="flex items-center flex-no-shrink text-white mr-6 no-underline">
        <img src="./../assets/lingua-ai-logo.png" alt="Lingua AI: Учим языки легко" class="block h-24 mr-4" >
        <span class="font-bold text-3xl font-sans">Lingua AI</span>
    </a>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>